export var PERMISSION = /* @__PURE__ */ ((PERMISSION2) => {
  PERMISSION2["TRANSACTIONAL_MESSAGING"] = "sms";
  PERMISSION2["MARKETING_SMS"] = "marketing_sms";
  PERMISSION2["MARKETING_WHATSAPP"] = "marketing_whatsapp";
  PERMISSION2["MARKETING_EMAIL"] = "marketing_email";
  PERMISSION2["AUTOMATIC_CHECKOUT"] = "automatic_checkout";
  PERMISSION2["MANAGE_ACCOUNT"] = "manage_account";
  return PERMISSION2;
})(PERMISSION || {});
export var PERMISSION_TYPE = /* @__PURE__ */ ((PERMISSION_TYPE2) => {
  PERMISSION_TYPE2["TRANSACTIONAL"] = "transactional";
  PERMISSION_TYPE2["MARKETING"] = "marketing";
  return PERMISSION_TYPE2;
})(PERMISSION_TYPE || {});
export var PERMISSION_GRANT_REASON = /* @__PURE__ */ ((PERMISSION_GRANT_REASON2) => {
  PERMISSION_GRANT_REASON2["KLAVIYO_WEBHOOK"] = "klaviyo_webhook";
  PERMISSION_GRANT_REASON2["SENDLANE_WEBHOOK"] = "sendlane_webhook";
  PERMISSION_GRANT_REASON2["ATTENTIVE_WEBHOOK"] = "attentive_webhook";
  PERMISSION_GRANT_REASON2["POSTSCRIPT_WEBHOOK"] = "postscript_webhook";
  PERMISSION_GRANT_REASON2["OPT_IN_API"] = "opt_in_api";
  PERMISSION_GRANT_REASON2["CHECKOUT_ONBOARD"] = "marketing_onboard";
  PERMISSION_GRANT_REASON2["CHECKOUT_EXTERNAL_WEBHOOK"] = "checkout_external_webhook";
  PERMISSION_GRANT_REASON2["CHECKOUT_APPROVE"] = "checkout_approve";
  PERMISSION_GRANT_REASON2["MESSAGE_INCOMING_CONSENT"] = "message_incoming_consent";
  PERMISSION_GRANT_REASON2["MESSAGE_INCOMING_SHORT_TOKEN_FLOW_START"] = "message_incoming_flow_start";
  PERMISSION_GRANT_REASON2["MESSAGE_INCOMING_KEYWORD_FLOW_START"] = "message_incoming_keyword_flow_start";
  PERMISSION_GRANT_REASON2["MANUAL_CALL"] = "manual_call";
  PERMISSION_GRANT_REASON2["MANUAL_MIGRATION"] = "marketing_migration";
  PERMISSION_GRANT_REASON2["AUDIT_RECONCILIATION"] = "audit_reconciliation";
  PERMISSION_GRANT_REASON2["LOAD_TESTING"] = "load_testing";
  PERMISSION_GRANT_REASON2["CORE_FLOW_START"] = "flow_start";
  PERMISSION_GRANT_REASON2["CUSTOM_FLOW_INITIALIZE"] = "custom_flow_initialize";
  PERMISSION_GRANT_REASON2["NEW_USER_ADDED"] = "new_user_added";
  PERMISSION_GRANT_REASON2["USER_REMOVED"] = "user_removed";
  PERMISSION_GRANT_REASON2["MARKETING_INCOMING_MESSAGE"] = "marketing_incoming_message";
  PERMISSION_GRANT_REASON2["MARKETING_ONE_OFF_MESSAGE"] = "marketing_one_off_message";
  PERMISSION_GRANT_REASON2["MARKETING_OPT_IN"] = "marketing_opt_in";
  PERMISSION_GRANT_REASON2["MARKETING_OPT_OUT"] = "marketing_opt_out";
  PERMISSION_GRANT_REASON2["MARKETING_WEBHOOK"] = "marketing_webhook";
  return PERMISSION_GRANT_REASON2;
})(PERMISSION_GRANT_REASON || {});
